const htmlTemplate = `<html><head></head><body><div>
  <div class="pdf-values">
    <div>
      <div>PDF Title</div>
      <div>STEWART TITLE GUARANTY COMPANY AUTHORIZED ISSUING AGENCY</div>
    </div>
    <div>
      <div>Legal 1</div>
      <div>Please be advised that as of {{date}}, {{officeDisplayName}} is an authorized policy Issuing Agent of Stewart Title Guaranty Company (“Stewart”), and is authorized, subject to the terms of the Underwriting Agreement, solely to issue its title policies and endorsements in accordance with Stewart’s underwriting practices and the terms and conditions of the policies, if and when issued for real estate within the State(s) listed above and for no other purpose. {{officeDisplayName}} is expressly not appointed as an agent of Stewart for purposes of providing abstracting or escrow or closing services or any other services not expressly authorized therein, and Stewart shall have no liability or responsibility for any claims or losses due to Issuing {{officeDisplayName}} as principal in providing such abstracting or escrow or closing services, or any other services not expressly authorized therein.</div>
    </div>
    <div>
      <div>Legal 2</div>
      <div>        
        <p>To become a Stewart Trusted Provider, the agency listed above underwent a rigorous due-diligence screening that includes a comprehensive audit; background and credit checks; licensing verification; and an in-depth review of the agency’s experience, business model, and policy loss history.</p>
        <p>As a Stewart Trusted Provider, this agency also undergoes periodic audits, as well as scheduled ongoing monitoring of key personnel, quarterly agency visits and more. See all of our Stewart Trusted Provider business standards and monitoring efforts at <a href="https://www.stewart.com/agency-services/stewart-trusted-providers">https://www.stewart.com/agency-services/stewart-trusted-providers</a>.</p>
      </div>
    </div>
    <div>
      <div>About Stewart Trusted</div>
      <div>About Stewart’s Trusted Provider™ Program</div>
    </div>
    <div>
      <div>Logo</div>
      <div>
        <picture>
          <source type="image/webp" srcset="./media_1404f229bc42ca1717fbdbad8407d95237c5e87f0.png?width=2000&amp;format=webply&amp;optimize=medium" media="(min-width: 600px)">
          <source type="image/webp" srcset="./media_1404f229bc42ca1717fbdbad8407d95237c5e87f0.png?width=750&amp;format=webply&amp;optimize=medium">
          <source type="image/png" srcset="./media_1404f229bc42ca1717fbdbad8407d95237c5e87f0.png?width=2000&amp;format=png&amp;optimize=medium" media="(min-width: 600px)">
          <img loading="lazy" alt="" src="./media_1404f229bc42ca1717fbdbad8407d95237c5e87f0.png?width=750&amp;format=png&amp;optimize=medium" width="1900" height="216">
        </picture>
      </div>
    </div>
  </div>
</div>
</body></html>`;

export default htmlTemplate;
